export default __webpack_public_path__ + "static/media/ikea-homesmart-02.463fc6b2.png";